import { Component, Directive, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';
// SERVICES
import { QuestionBankService } from '@services/question-bank/question-bank.service';
import { AlertService } from '@services/notification/alert.service';
import { QuestionService } from '@services/question/question.service';
// MODELS
import { QuestionBank } from '@models/question-bank/QuestionBank';
import { Response } from '@models/response-api/ResponseApi';
import { Question } from '@models/question/Question';
// TODO : TAG GTM
declare var dataLayer: any;
@Directive({ selector: 'reagent-table' })
export abstract class ReagentTableBase implements OnInit {
	questionBank: QuestionBank;
	subscription = new Subscription();
	displayedColumns: string[] = ['content', 'questionType', 'action'];
	dataSource: Question[] = [];
	isFirstLoadingData = true;
	cct: string | null = '';
	typeSchool: string | null = '';
	constructor(
		protected route: ActivatedRoute,
		protected router: Router,
		protected alertService: AlertService,
		protected questionBankService: QuestionBankService,
		protected questionService: QuestionService
	) {
		this.questionBank = this.route.parent?.snapshot.data['data'] as QuestionBank;
	}

	ngOnInit() {
		this.cct = localStorage.getItem('cct');
		this.typeSchool = localStorage.getItem('typeSchool');
		this.loadData();
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	showMessageEmpty() {
		return !this.isFirstLoadingData && this.dataSource.length === 0;
	}

	abstract navigateQuestion(question: Question): void;

	abstract addNewReagent(): void;

	loadData() {
		this.subscription.add(
			this.questionBankService
				.getById(this.questionBank.id!)
				.subscribe({
					next: (x: Response) => {
						if (x.success) {
							const data = x.data as QuestionBank;
							this.dataSource = (data.questions as Question[]) || [];
						} else {
							dataLayer.push({
								event: 'error_message', //Static data
								content_group: 'Banco de preguntas', //Dynamic data
								error_messgae_text: x.message, //Dynamic data
								error_messgae_location: 'Cargar datos', //Dynamic data
								cct: this.cct, //Dynamic data
								school_type: this.typeSchool,
							});
							this.alertService.showError(x.message);
						}
					},
					error: (error: HttpErrorResponse) => {
						console.log(error);
						this.alertService.showSmallErrorServer();
					},
				})
				.add(() => {
					this.isFirstLoadingData = false;
				})
		);
	}

	async confirmDeletionQuestion(question: Question) {
		if (await this.alertService.showConfirmationDeletion()) {
			this.deleteQuestion(question);
		}
	}

	deleteQuestion(question: Question) {
		this.subscription.add(
			this.questionService
				.remove(question)
				.subscribe({
					next: (x: Response) => {
						if (x.success) {
							this.alertService.showSuccess(x.message);
							this.loadData();
						} else {
							dataLayer.push({
								event: 'error_message', //Static data
								content_group: 'Banco de preguntas', //Dynamic data
								error_messgae_text: x.message, //Dynamic data
								error_messgae_location: 'Eliminar pregunta', //Dynamic data
								cct: this.cct, //Dynamic data
								school_type: this.typeSchool,
							});
							this.alertService.showError(x.message);
						}
					},
					error: (error: HttpErrorResponse) => {
						console.log(error);
						this.alertService.showSmallErrorServer();
					},
				})
				.add(() => {
					this.isFirstLoadingData = false;
				})
		);
	}
}
